<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">inventoty_certificate_list</div>
    <div :class="'container ' + pageContainerSize">
      <search-control 
        style="padding-bottom: 10px;width: 100%" 
        :field_names="allSearchFields" 
        @onSearchClear="onSearchClear"
        @change="searchControlChangedDatasource">
        </search-control>
      <ag-grid-vue 
        style="width: 100%; height: 325px;margin-left:-15px" class="ag-blue" 
        :gridOptions="gridOptions"></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数　
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
      <div class="row" style="margin-top:20px;">
        <div class="col-xs-6"></div>
        <div class="col-xs-6">
        <button
        :disabled="formExportFileDisabled"
        class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;"
        @click="initExportFile" >出力</button>
          <!-- <router-link
            tag="button"
            to="/inventory_report_check"
            type="button"
            style="min-width:100px;float: right;margin-right: 10px;"
            class="btn btn-primary"
            >棚卸報告確認</router-link> -->
          <button
            :disabled="checkUserPermission(acl.inventory_report,permissionMode.EXPORT) == false"
            class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;"
            @click="addNewReport"
            >棚卸報告</button>
        </div>
      </div>
      <file-download-modal tag="runinventorycertificatelistDownloadModal" @close="onCloseExportFile"/>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from 'lodash';
import uuid from "uuid";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_inventory_certificate_list";
import { utils } from "@/libs/utils";
import _debug from "debug";
var mdebug = _debug("esma:inventory_certificate_list");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import constants from "@/rules/constants";
import { bus } from "@/libs/bus";
import fileDownloadModal from '@/components/modals/file-download-modal';

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue,
    'file-download-modal':fileDownloadModal,
  },
  data() {
    return {
      api_name: "inventory_certificate_list",
      page_acl: acl.inventory,
      inventory_sub_search:{}
    };
  },
  computed: {
    EditableUser(){
      return (Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR 
      || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF);
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    allSearchFields(){
      return [
          utils.extend(fields.certificate_software_number, {label:"証書管理番号"}),
          fields.license_name,
          fields.software_name,
          fields.license,
          fields.effective_number,
          fields.remaining_number
          ];
    },
    tabFieldList() {
      return [
        utils.extend(fields.certificate_software_number, {tab_label:"証書管理番号",tab_size:20}),
        utils.extend(fields.license_name, {tab_size:30}),
        utils.extend(fields.software_name, {tab_size:30}),
        utils.extend(fields.license, {tab_size:10}),
        utils.extend(fields.effective_number, {tab_size:10}),
        utils.extend(fields.remaining_number, {tab_size:10})
      ];
    }
  },
  methods: {
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runinventorycertificatelistDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        sub_search : this.inventory_sub_search,
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url:"/inventory_certificate_list/export_data/"
      });
    },
    onCloseExportFile(){},
    addNewReport(){
      window.sessionStorage.setItem('device_back_to_list', "/inventory_management");
      return this.$router.push({ name: "page_0071_inventory_report", params: {  seq_id:"new" ,sub_search:this.inventory_sub_search} });
    },
    onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:false,show_checkbox:false,force_sort:{id:"certificate_software_number",direction:"asc"}})
    },

    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    onSearchClear(){
      this.emulateSearchControlChangedDatasource(true)
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    bus.$on("inventory_sub_search",(data)=>{
          this.inventory_sub_search = data.search_data;
          this.gridOptions.api.purgeInfiniteCache();
          this.countRows("inventory_certificate_list");
    })
    this.inventory_sub_search = this.$props.searchData;
    this.emulateSearchControlChangedDatasource()
  },
  beforeDestroy() {
    bus.$off("inventory_sub_search")
  },
  beforeMount() {
    // this.$store.state[this.stateCurrentRow]= {};
    this.api_request_options = {sub_search:"inventory_sub_search"};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource({load_only_with_filter:true,loaded_cb:(_err,_data)=>{
    }});
  },
  props: ["searchData"]
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// inventory_certificate_list.vue?a11fa14e